import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import SessionSvg from "../../../../public/images/session.svg";
import { useTranslation } from "react-i18next";
import { cls } from "app/utils";

export default function ProductSessionsSummary({ product, onDetailsClick }) {
  const { t } = useTranslation();
  const [showReadMore, setShowReadMore] = useState(false);
  const descriptionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = descriptionRef.current;
    if (el) {
      setShowReadMore(el.scrollHeight > el.clientHeight);
    }
  }, [product.description]);

  if (!product) {
    return null;
  }

  const rateLinks = product.rateLinks ?? [];
  let sessionDisplay: React.ReactNode = null;

  if (rateLinks.length === 0) {
    sessionDisplay = null;
  } else if (rateLinks.length === 1) {
    const r = rateLinks[0];
    const isUnlimited = r.quantity == null;

    if (!r.title) {
      sessionDisplay = (
        <span className={styles.product_session}>
          <img src={SessionSvg} alt="tags" className={styles.card_icon} />
          <span>
            {isUnlimited ? <span className={styles.infinitySymbol}>&infin;</span> : r.quantity} {t('Sessions')}
          </span>
        </span>
      );
    } else {
      sessionDisplay = (
        <div className={styles.product_session_summary}>
          <img src={SessionSvg} alt="tags" className={styles.card_icon} />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <span className={styles.session_summary_text}>{r.title}</span>
            <span className={styles.count}>
              {isUnlimited ? <span className={styles.infinitySymbol}>&infin;</span> : r.quantity} {' '}{t('Sessions')}
            </span>
          </div>
        </div>
      );
    }
  } else {
    const hasUnlimited = rateLinks.some((r) => r.quantity == null);
    const totalSessions = rateLinks.reduce((acc, r) => acc + (r.quantity ?? 0), 0);
    sessionDisplay = (
      <div className={styles.product_session_summary}>
        <img src={SessionSvg} alt="tags" className={styles.card_icon} />
        <div className={styles.session_summary_text}>
          {hasUnlimited
            ? <><span className={styles.infinitySymbol}>&infin;</span> {t('Sessions')} ({rateLinks.length} {t('types')})</>
            : t('{{sessions}} Session of {{types}} types', { sessions: totalSessions, types: rateLinks.length })
          }
        </div>
        <button onClick={onDetailsClick} className={styles.details_link}>
          {t("Details")}
        </button>
      </div>
    );
  }

  return (
    <div className={styles.product_info}>
      {sessionDisplay}

      <div
        className={cls(styles.product_details, {
          [styles.product_details_fade]: showReadMore,
        })}
        ref={descriptionRef}
      >
        {product.description}
      </div>

      {showReadMore && (
        <button onClick={onDetailsClick} className={styles.read_more}>
          {t("Read more...")}
        </button>
      )}
    </div>
  );
}
